export const ACTIVITY_FETCH_REQUEST = 'ACTIVITY_FETCH_REQUEST';
export const ACTIVITY_FETCH = 'ACTIVITY_FETCH';
export const ACTIVITY_FETCH_BY_ID_REQUEST = 'ACTIVITY_FETCH_BY_ID_REQUEST';
export const ACTIVITY_FETCH_BY_ID = 'ACTIVITY_FETCH_BY_ID';

export const ACTIVITY_CLEAR = 'ACTIVITY_CLEAR';
